import { openAlertModal } from '@inflearn/ds-react';
import { Trans, useTranslation } from 'next-i18next';

export function useDeviceDeleteGuardModal() {
  const { t } = useTranslation();

  const openDeleteGuardModal = () => {
    openAlertModal({
      withCloseButton: true,
      size: 'sm',
      title: t('마이페이지_기기관리_삭제불가_타이틀'),
      children: <Trans i18nKey="마이페이지_기기관리_삭제불가_설명" components={{ br: <br /> }} />,
      labels: {
        confirm: t('닫기'),
      },
      footerType: 'right',
      confirmProps: {
        variant: 'default',
        type: 'submit',
        size: 'md',
        fullWidth: true,
      },
    });
  };

  return {
    openDeleteGuardModal,
  };
}
